export default defineNuxtRouteMiddleware(async (to, _from) => {
  if (!to.path.startsWith('/partners/')) return

  const code = to.query.code as string | undefined
  if (code) {
    const runtimeConfig = useRuntimeConfig()
    const isLocal = (runtimeConfig.public.env || 'local') === 'local'

    const partnersSubCodeCookie = useCookie<string | null>('partnersSubCode', {
      maxAge: 60 * 60 * 24, // 24시간
      secure: !isLocal,
      sameSite: isLocal ? 'lax' : 'none',
      domain: isLocal ? undefined : '.usimsa.com',
      path: '/'
    })
    partnersSubCodeCookie.value = code
  }

  await usePartnerLoader(to.params.partner as string) // 파트너 정보 로드 후 slot 렌더링
})
